// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ViewsAuthorizeSvg from '@rsuite/icon-font/lib/application/ViewsAuthorize';
var ViewsAuthorize = createSvgIcon({
  as: ViewsAuthorizeSvg,
  ariaLabel: 'views authorize',
  category: 'application',
  displayName: 'ViewsAuthorize'
});
export default ViewsAuthorize;